import ManualStorageRetrievalRequest from "../../components/ManualStorageRetrievalRequest";

const ManualStorageRetrievalRequestPage = () => {
  return <ManualStorageRetrievalRequest />;
};

export default ManualStorageRetrievalRequestPage;
